import axios from 'axios';

const apiSemCategoria = axios.create({
  baseURL: 'https://api.merkator.alweb.com.br',
  headers: { Authorization: 'Basic bWVya2F0b3I6RkQuc2pha2llMTI3MTIw' },
});

export default apiSemCategoria;
